export { default } from './ServiceList'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Service/ServiceList/index.js